module.exports = __webpack_public_path__ + "img/jorge.eab03c05.webp";